import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"
import { MaterialTypePageState, NewMaterialTypeRequest } from "./_model"
// import { NewRoleData, UserRolePageState } from "./_model"

export const postNewMaterialType = (data: NewMaterialTypeRequest) => {
  return iAxios.post(API_URLs.settings.materialType.postMaterialType, data)
  .then(r => {
    return r.data
  })
  .catch(e => {
    return e
  })
}

export const getMaterialTypeList = (pageState: MaterialTypePageState) => {
  const obj: any = {...pageState}
  Object.keys(pageState).forEach((key: any) => {
    if (key === 'order') {
      console.log('The order key ')
      obj['order[' + (pageState?.order?.dataKey ?? '') + ']'] = pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString()
    }
    
  })
  delete obj['order']
  return iAxios.get(API_URLs.settings.materialType.getMaterialTypes + '?' + new URLSearchParams(obj) )
  .then(r => {
    return r?.data
  })
  .catch(e => {
    return null
  })
}

export const getMaterialTypeById = (id: string) => {
  return iAxios.get(API_URLs.settings.materialType.getMaterialTypeById?.replace('{id}', id))
  .then(r => r.data)
  .catch(e => null)
}

export const patchMaterialTypeById = (id: string, data: NewMaterialTypeRequest) => {
  return iAxios.patch(API_URLs.settings.materialType.patchMaterialTypeById?.replace('{id}', id), {...data, id}, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    }
  })
  .then(r => {
    return r.data
  })
  .catch(e => {
    return e
  })
}

export const deleteMaterialTypeById = (id: string) => {
  return iAxios.delete(API_URLs.settings.materialType.deleteMaterialTypeById?.replace('{id}', id))
  .then(r => {
    return {success: true, data: r.data}
  })
  .catch(e => null)
}